var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235 176",
    width: 235,
    height: 176,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo02-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.59-3.15h237.18v180.3h-237.18z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #193c34;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t\t.s1 { fill: none;stroke: #e8ba3a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m209.2 157.9h-0.5c-2.9 0-5.2-2.3-5.2-5.2v-47.1h10.9v47.1c0 2.9-2.3 5.2-5.2 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m190.7 157.9h-0.2c-2.8 0-5.2-2.3-5.2-5.2v-47.1h10.6v47.1c0 2.9-2.3 5.2-5.2 5.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1254",
    fillRule: "evenodd",
    className: "s0",
    d: "m174.2 29.8v20.3c0 2.8-2.3 5-5 5h-5.2v10.1l-10.1-10.1h-15.2c-2.8 0-5.1-2.2-5.1-5v-20.3c0-2.7 2.3-5 5.1-5h30.5c2.7 0 5 2.3 5 5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1258",
    fillRule: "evenodd",
    className: "s1",
    d: "m148.9 41.3l3.8 3.8 7.5-7.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1262",
    fillRule: "evenodd",
    className: "s0",
    d: "m201 95.5h8.4c5.5 0 10-4.5 10-10v-10.3c0-5.5-4.5-10-10-10h-20.1c-5.6 0-10.1 4.5-10.1 10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1266",
    fillRule: "evenodd",
    className: "s0",
    d: "m197.6 85.5h11.8v-10.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1282",
    fillRule: "evenodd",
    className: "s0",
    d: "m204.3 105.6h10.1v-10.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1270",
    fillRule: "evenodd",
    className: "s0",
    d: "m189.3 50.1c0 5.6 4.5 10.1 10 10.1 5.6 0 10.1-4.5 10.1-10.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m187.9 42.7c0-6.3 5.2-11.5 11.5-11.5 6.4 0 11.6 5.2 11.6 11.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1274",
    fillRule: "evenodd",
    className: "s1",
    d: "m180.9 95.5l3.3 10.1h20.1l-10-30.4h-20.1l3.4 10.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1278",
    fillRule: "evenodd",
    className: "s0",
    d: "m179.2 95.5h5v-10h-5c-2.8 0-5 2.2-5 5 0 2.8 2.2 5 5 5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m111.1 157c0 0 4.6-5.5 9.4-2.3 0 0 3.4-10.8 12.9-4.6 0 0 3.1-5.3 8-4.6 0 0 4.1-9.1 12.7-8.5 7.2 0.5 10.9 5.8 10 11.1 0 0 11.5-0.5 12.3 8.6 0 0.1 0.1 0.1 0.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m13.1 164.5c0-3.4 2.6-6 5.9-6h196c3.3 0 5.9 2.6 5.9 6v2.2c0 3.3-2.6 6-5.9 6h-196c-3.3 0-5.9-2.7-5.9-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m139.8 133.5c1-3 7.7-18.8 25.3-12.8 0.2 0 0.3 0.3 0.3 0.6-0.9 2.9-6.6 19.6-25.3 12.8-0.3-0.1-0.4-0.4-0.3-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m114.8 123.2c2 5.2 8.5 16.8 24.6 10.9 0.3-0.1 0.4-0.4 0.3-0.6-0.7-2.2-4.5-11.1-13.2-13.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m139.7 133.5v11.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1268-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1270-2",
    fillRule: "evenodd",
    className: "s0",
    d: "m64.9 48.7c-2.6 4.2-1.2 9.8 3 12.4 4.2 2.6 9.7 1.2 12.3-3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m68 41.4c2.9-4.9 9.3-6.4 14.1-3.4 4.9 2.9 6.4 9.3 3.4 14.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m41.6 92.3l72.1 19.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m110.8 102.8l11.9 3c3.3 0.9 5.3 4.3 4.5 7.6l-1 3.9c-0.8 3.3-4.3 5.4-7.6 4.5l-11.9-3c-0.8-0.2-1.3-1-1.1-1.8l3.4-13.1c0.2-0.8 1-1.3 1.8-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m48.7 77.7c-1.1 1.2-1.5 2.9-1 4.5l3.3 10.4c0.7 2.2-0.5 4.7-2.7 5.5l-0.6 0.3c-2.3 0.9-4.8-0.2-5.8-2.4l-8.5-19.9c-1-2.3 0-4.9 2.2-5.9l20.2-9.2c1.4-0.6 3-0.5 4.3 0.3l12.4 8q0.9 0.6 1.4 1.5l9.8 18.9q0.3 0.6 0.8 1l6.1 5c1.7 1.5 2 4.1 0.8 6-1.3 2.2-4 3-6.2 1.9l-7.7-4.4c-0.8-0.3-1.4-0.9-1.9-1.6l-6-9.3c-0.4-0.6-1.1-0.6-1.5-0.1l-5.9 8c-1.2 1.8-1.1 4.2 0.4 5.8l15.5 16.7c0.8 0.8 1.2 1.9 1.2 3l0.2 30.5c0.1 3.1-2.5 5.7-5.6 5.7-2.9 0-5.4-2.3-5.6-5.2l-2-24.7c-0.1-1-0.5-2-1.3-2.8l-13.1-13.5c-0.8-0.8-2.2-0.1-2 1l2.9 17c0.2 1.2-0.1 2.4-0.7 3.4l-16.4 22.1c-1.7 2.3-4.8 3-7.2 1.5-2.4-1.4-3.3-4.5-2.1-7l11.2-21c0.5-1 0.6-2 0.3-3l-4.5-18.5c-0.7-3.1-0.3-6.4 1.3-9.2l4.6-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m62 38.7l27.4 18.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m181 43.6h36.2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo02.da3091c2d58c0b3fd631aa50118acbdc.svg";
export { ForwardRef as ReactComponent };